export enum PartnerBankAliasTypeEnum {
  CARD = 'card',
  BANK = 'bank',
}
